<template>
    <div class="col-12 mx-auto">
        <div class="btn-toolbar justify-content-between mt-sm-1 mt-md-3 mb-1" role="toolbar">
            <div class="form-inline col-lg-6 col-md-12">
                <span v-if="showParticipationRequestsGridSettings">
                    <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                       @click.stop="changeGridSettings"
                       data-toggle="tooltip"
                       :title="settingsTooltipText"></i>
                </span>
            </div>

            <div class="input-group" :class="showParticipationRequestsGridSettings? 'col-lg-6 col-md-12':'col-12'">
                <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters"
                       type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                <button class="btn btn-secondary" @click.stop="massSearch">
                    <i class="fas fa-search"></i>
                    {{ $t('buttons.search.btnText') }}
                </button>
                <button class="btn btn-secondary"
                        @click.stop="clearFilters">
                    <i class="fas fa-times"></i>
                    {{ $t('buttons.clearFilters.btnText') }}
                </button>
            </div>
        </div>

        <div v-if="showParticipationRequestsGridSettings">
            <GridUserSettings ref="participationRequestsGridSettings"
                              :visible="showParticipationRequestsGridSettingsForm"
                              :grid="$refs['participationReguestsGrid']"
                              :componentName="componentName">
            </GridUserSettings>
        </div>

        <div>
            <kendo-datasource ref="datasource1"
                              :transport="transportSettings"
                              :schema-model-id="'id'"
                              :schema-model-fields="schemaModelFields"
                              :schema-total="'total'"
                              :schema-data="'data'"
                              :page-size='gridOptions.pageable.size'
                              :server-paging="true"
                              :server-sorting="true"
                              :server-filtering="true"
                              :error="dataSourceError"
                              :requestEnd="datasorceRequestEnd">
            </kendo-datasource>

            <kendo-grid ref="participationReguestsGrid"
                        data-source-ref="datasource1"
                        :pageable="gridOptions.pageable"
                        :navigatable="gridOptions.navigatable"
                        :editable="gridOptions.editable"
                        :filterable="gridOptions.filterable"
                        :reorderable="gridOptions.reorderable"
                        :resizable="gridOptions.resizable"
                        :groupable="gridOptions.groupable"
                        :allow-copy="gridOptions.allowCopy"
                        :sortable-mode="gridOptions.sortable.mode"
                        :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                        :sortable-show-indexes="gridOptions.sortable.showIndexes"
                        :column-menu="gridOptions.columnMenu"
                        :selectable="gridOptions.selectable"
                        :scrollable="gridOptions.scrollable"
                        :toolbar="toolbar"
                        :excel="gridOptions.excel"
                        :dataBound="dataBound">
                <kendo-grid-column :field="'id'"
                                   :filterable="false"
                                   :title="$t('participationRequest.gridHeaders.id')"
                                   :width="100"
                                   :hidden="true"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column
                                   :template="btnsTemplate"
                                   field="btnsColumn"
                                   :title="$t('actions')"
                                   :sortable="false"
                                   :filterable="false"
                                   :width="150"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'creatorFullName'"
                                   :title="$t('participationRequest.gridHeaders.name')"
                                   :width="250"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'creatorUsername'"
                                   :title="$t('participationRequest.gridHeaders.username')"
                                   :width="200"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'creatorEmail'"
                                   :title="$t('participationRequest.gridHeaders.email')"
                                   :width="200"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'creatorPositionNom'"
                                   :title="$t('participationRequest.gridHeaders.position')"
                                   :width="200"
                                   :hidden="isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'creatorPositionNomEn'"
                                   :title="$t('participationRequest.gridHeaders.position')"
                                   :width="200"
                                   :hidden="!isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'creatorPosStatNom'"
                                   :title="$t('participationRequest.gridHeaders.positionStatistic')"
                                   :width="200"
                                   :hidden="isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'creatorPosStatNomEn'"
                                   :title="$t('participationRequest.gridHeaders.positionStatistic')"
                                   :width="200"
                                   :hidden="!isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'creatorPositionStr'"
                                   :title="$t('participationRequest.gridHeaders.positionStr')"
                                   :width="200"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'institutionName'"
                                   :title="$t('participationRequest.gridHeaders.institutionName')"
                                   :width="200"
                                   :hidden="isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'institutionNameEn'"
                                   :title="$t('participationRequest.gridHeaders.institutionName')"
                                   :width="200"
                                   :hidden="!isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'institutionCity'"
                                   :title="$t('participationRequest.gridHeaders.institutionCity')"
                                   :width="200"
                                   :hidden="isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'institutionCityEn'"
                                   :title="$t('participationRequest.gridHeaders.institutionCity')"
                                   :width="200"
                                   :hidden="!isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'createdAtUtc'"
                                   :title="$t('participationRequest.gridHeaders.createdAtUtc')"
                                   :width="150"
                                   :format="customDateTimeFormat"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'updatedAtUtc'"
                                   :title="$t('participationRequest.gridHeaders.updatedAtUtc')"
                                   :width="150"
                                   :format="customDateTimeFormat"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'formName'"
                                   :title="$t('participationRequest.gridHeaders.formName')"
                                   :width="200"
                                   :hidden="isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'formNameEn'"
                                   :title="$t('participationRequest.gridHeaders.formName')"
                                   :width="200"
                                   :hidden="!isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'formType'"
                                   :title="$t('participationRequest.gridHeaders.formType')"
                                   :width="200"
                                   :hidden="isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'formTypeEn'"
                                   :title="$t('participationRequest.gridHeaders.formType')"
                                   :width="200"
                                   :hidden="!isEnVersion"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'status'"
                                   :title="$t('participationRequest.gridHeaders.status')"
                                   :width="200"
                                   :template="statusCellTemplate"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
                <kendo-grid-column :field="'eventName'"
                                   :title="$t('participationRequest.gridHeaders.eventName')"
                                   :width="200"
                                   :lockable="true"
                                   :locked="false">
                </kendo-grid-column>
            </kendo-grid>
        </div>

        <PersonDetailsModal v-model="personModel" :show="showPersonDetails" :allowEdit="false"
                            @onClose="onPersonDetailsClose"></PersonDetailsModal>
        <FormEntryDetailsModal v-model="formEntryDetailsModel" :show="showFormEntryDetails"
                               @onClose="onFormEntryDetailsClose"></FormEntryDetailsModal>
    </div>
</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import GridUserSettings from "@/components/grid/GridSettingsWrapper";
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import PersonDetailsModal from '@/components/person/details.modal';
    import FormEntryDetailsModal from '@/components/forms/entryView/details.modal';
    import { RegisterFieldValueQueryFilter } from '@/models/enums';
    import personService from '@/services/person.service';
    import { mapGetters } from 'vuex';


    export default {
        name: 'participation-requests-grid',
        components: {
            GridUserSettings,
            PersonDetailsModal,
            FormEntryDetailsModal
        },
        created: function () {
            window.JSZip = JSZip
        },
        props: {
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            eventId: {
                type: Number,
                default: 0,
            },
            componentName: {
                default: 'ParticipationRequestsGrid',
                type: String
            },
        },
        data() {
            return {
                showParticipationRequestsGridSettings: false,
                showParticipationRequestsGridSettingsForm: false,
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                searchQuery: '',
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true },
                    createdAtUtc: { name: 'createdAtUtc', type: 'date', editable: false, nullable: true, visible: true },
                    updatedAtUtc: { name: 'updatedAtUtc', type: 'date', editable: false, nullable: true, visible: true },
                    creatorId: { name: 'creatorId', type: 'string', editable: false, nullable: true, visible: true },
                    creatorUsername: {
                        name: 'creatorUsername',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    creatorEmail: {
                        name: 'creatorEmail',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    creatorFullName: {
                        name: 'creatorFullName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    creatorPosition: {
                        name: 'creatorPosition',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    creatorPositionEn: {
                        name: 'creatorPositionEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    formName: { name: 'formName', type: 'string', editable: false, nullable: true, visible: true },
                    formNameEn: { name: 'formNameEn', type: 'string', editable: false, nullable: true, visible: true },
                    eventName: { name: 'eventName', type: 'string', editable: false, nullable: true, visible: true },
                    formType: { name: 'formType', type: 'string', editable: false, nullable: true, visible: true },
                    formTypeEn: { name: 'formTypeEn', type: 'string', editable: false, nullable: true, visible: true },
                    status: { name: 'status', type: 'string', editable: false, nullable: true, visible: true },
                    personId: { name: 'personId', type: 'number', editable: false, nullable: true, visible: true },
                    registerEntityId: {
                        name: 'registerEntityId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionName: {
                        name: 'institutionName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionNameEn: {
                        name: 'institutionNameEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionCity: {
                        name: 'institutionCity',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    institutionCityEn: {
                        name: 'institutionCityEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true
                    },
                    creatorPositionNom: { name: 'creatorPositionNom', type: 'string', editable: false, nullable: true, visible: true },
                    creatorPositionNomEn: { name: 'creatorPositionNomEn', type: 'string', editable: false, nullable: true, visible: true },
                    creatorPosStatNom: { name: 'creatorPosStatNom', type: 'string', editable: false, nullable: true, visible: true },
                    creatorPosStatNomEn: { name: 'creatorPosStatNomEn', type: 'string', editable: false, nullable: true, visible: true },
                    creatorPositionStr: { name: 'creatorPositionStr', type: 'string', editable: false, nullable: true, visible: true },
                },
                gridOptions: {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel'],
                    excel: {
                        fileName: 'ParticipationRequests.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/participant/requests',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                working: false,
                personModel: null,
                showPersonDetails: false,
                formEntryDetailsModel: null,
                showFormEntryDetails: false,
            }
        },
        methods: {
            beforeSend: function (req) {
                if (this.authToken) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.authToken);
                }
            },
            dataBound(e) {
                if (e.sender.options.dataSourceRef == 'datasource1'
                    && this.showSettingsBtn
                    && !this.showParticipationRequestsGridSettings) {
                    this.showParticipationRequestsGridSettings = true;
                }
            },
            datasorceRequestEnd(e) {

            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {

                    const newOptions = { eventId: this.eventId, request: options };
                    return kendo.stringify(newOptions);
                }
            },
            changeGridSettings() {
                this.showParticipationRequestsGridSettingsForm = !this.showParticipationRequestsGridSettingsForm;
            },
            refresh() {
                const grid = this.$refs.participationReguestsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.participationReguestsGrid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.participationReguestsGrid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.participationReguestsGrid,
                        btns: [
                            {
                                name: "details",
                                text: this.$t('buttons.details.btnText'),
                                tooltip: this.$t('buttons.details.btnText'),
                                class: 'btn btn-primary',
                                icon: "fas fa-eye",
                                show: true,
                                clickHandler: this.formEntryDetailsBtnClick
                            },
                            {
                                name: "personDetails",
                                text: "",
                                tooltip: this.$t('buttons.personDetails.btnText'),
                                class: 'btn btn-primary',
                                icon: "fas fa-info-circle",
                                show: true,
                                clickHandler: this.personDetailsBtnClick
                            }
                        ]
                    }
                }
            },
            statusCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' + (dataItem.status.indexOf('Active') >= 0 ? 'badge-success' : (dataItem.status.indexOf('Passed') >= 0 ? 'badge-warning' : 'badge-info')) + '">' + kendo.htmlEncode(dataItem.status) + '</span>';

                return templateHtml;
            },
            personDetailsBtnClick(args) {
                if (!this.claims.tempRanking.read) {
                    return this.$router.push(`/unauthorized`);
                }
                this.showPersonDetailsModal(Number(args.personId));
            },
            showPersonDetailsModal(id) {
                personService
                    .getById(id)
                    .then(response => {
                        let model = response.data;
                        if (model) {
                            this.personModel = model;
                            this.showPersonDetails = true;
                        } else {
                            this.editModel = null;
                            this.showPersonDetails = true;
                        }
                    })
                    .catch(error => {
                        this.personModel = null;
                        this.showPersonDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onPersonDetailsClose() {
                this.showPersonDetails = false;
                this.personModel = null;
            },
            formEntryDetailsBtnClick: function (args) {
                if (args.id) {
                    this.showFormEntryDetailsModal(args, RegisterFieldValueQueryFilter.Active);
                } else {
                    this.$vs.notify({
                        title: this.$t('notifications.noForm'),
                        text: this.$t('notifications.thereIsNoConnectedForm'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })
                }
            },
            showFormEntryDetailsModal(args, filter) {
                this.$api.dynamicForm
                    .getEntryDetails(args.id, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.formEntryDetailsModel = model;
                            this.formEntryDetailsModel.formNameEn = args.formNameEn;
                            this.formEntryDetailsModel.eventName = args.eventName;
                            this.formEntryDetailsModel.creatorFullName = args.creatorFullName;
                            this.formEntryDetailsModel.createdAtUtc = args.createdAtUtc;
                            this.formEntryDetailsModel.updatedAtUtc = args.updatedAtUtc;

                            this.showFormEntryDetails = true;
                        }
                    })
                    .catch(error => {
                        this.formEntryDetailsModel = null;
                        this.showFormEntryDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onFormEntryDetailsClose() {
                this.showFormEntryDetails = false;
                this.formEntryDetailsModel = null;
            },
        },
        mounted() {

        },
        computed:
        {
            ...mapGetters(['dateTimeFormat', 'isEnVersion', 'claims', 'authToken']),
            customDateTimeFormat() {
                return `{0: ${this.dateTimeFormat}}`;
            },
            toolbar: function () {
                return [{ name: 'excel', text: this.$t('buttons.excelExport.tooltipText') }]
            },
        }
    }
</script>


<style>
    /*
        Use the DejaVu Sans font for display and embedding in the PDF file.
        The standard PDF fonts have no support for Unicode characters.
    */
    .k-pdf-export .k-grid {
        font-family: 'DejaVu Sans', 'Arial', sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit,
    .k-grid-details,
    .k-grid-delete,
    .k-grid-pdf,
    .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
